// src/components/navigation/fab.tsx
import React from "react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button-new";
import { useFab } from "./fab-context";
import { useNavigationRail } from "./rail-context";

export function Fab() {
    const { action } = useFab();
    const { isMobile, expanded } = useNavigationRail();

    if (!action) return null;

    const { icon: Icon, label, onClick, color = "primary", disabled } = action;

    return (
        <div
            className={cn(
                "transition-all duration-300",
                // Mobile: Fixed position at bottom right
                isMobile && "fixed bottom-6 right-6 z-50",
                // Desktop: Part of the rail content
                !isMobile && "px-4"
            )}
        >
            <Button
                onClick={onClick}
                disabled={disabled}
                variant={"default"}
                size={isMobile ? "lg" : "default"}
                className={cn(
                    "rounded-full",
                    isMobile && "h-14 w-14 shadow-xl",
                    !isMobile && expanded && "w-full shadow-md",
                    !isMobile && !expanded && "w-12 h-12 shadow-md"
                )}
            >
                <Icon
                    className={cn("size-6", !isMobile && expanded && "mr-2")}
                />
                {!isMobile && expanded && <span>{label}</span>}
            </Button>
        </div>
    );
}
